import { PersistentStoreName } from 'stores/_utils/persistentStore/persistenceStoresCleanUpMap'
import { persistentInit } from 'stores/_utils/persistentStore/persistentStore'

// One remembered selection per dashboard (keyed by the dashboard's stable config id, e.g. 'pest-now').
export type TDashboardPreference = {
  // Stringified property id (matches the Select option value), or null if none resolved yet.
  // Used by single-property dashboards (pest).
  propertyId: string | null
  // Stringified property ids for multi-property dashboards (water). Single- and multi-property
  // dashboards never share an id, so each only ever reads/writes its own field.
  propertyIds?: string[]
  // Date range as ISO strings — moment objects can't be persisted.
  dateFrom: string
  dateTo: string
}

export type TDashboardsStoreState = {
  preferencesByDashboardId: Record<string, TDashboardPreference>
}

// Persists the user's last property + date range per dashboard to ionic storage, so each dashboard
// reopens where they left off. Dedicated store (not userDetailsStore) to keep this throwaway-MVP
// feature self-contained — removable in one shot. Survives app-version bumps (added to
// STORES_TO_NOT_RESET_UNLESS_IN_CLEANUP_MAP).
export const dashboardsStore = persistentInit<TDashboardsStoreState>({
  initialState: {
    preferencesByDashboardId: {},
  },
  keysToPutInPersistentStorage: {
    preferencesByDashboardId: true,
  },
  keysToPutInURL: {
    preferencesByDashboardId: false,
  },
  storeName: PersistentStoreName.DASHBOARDS_STORE,
})
